export const SUPABASE_API_BASE_URL = "https://api.supabase.com";
